/**
 * React Router Configuration for Backoffice
 * @implements US-099 - Backoffice Dashboard View
 *
 * Routes:
 * - / : Project listing page
 * - /projects/:projectId/dashboard : Dashboard for a specific project
 */

import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { ProjectListPage, DashboardPage } from '@/pages';

/**
 * Route definitions
 * @implements US-099 - Dashboard accessible at /projects/:id/dashboard
 */
const routes: RouteObject[] = [
  {
    path: '/',
    element: <ProjectListPage />,
  },
  {
    path: '/projects/:projectId/dashboard',
    element: <DashboardPage />,
  },
];

export const router = createBrowserRouter(routes);
